<template>
    <div class="pb-1 pr-1">
        <h6 class="title is-6 m-2">{{title}}</h6>
        <div v-if="isNew">
          <p>{{address}}</p> <br>
          <button @click="addRestaurant" class="button is-small is-link" >Add</button>
          
        </div>
        <div v-else>
          <div>{{this.address}}</div>
          <button class="button is-small is-warning is-inverted" @click="goToRestaurant"><i class="fas fa-store-alt"></i></button>
        </div>
    </div>
</template>

<script>
import { db, auth } from "@/firebaseConfig"
import router from '../router'

// https://stackoverflow.com/questions/50088994/rendering-vuejs-components-into-a-google-map-infowindow
export default {
    name: "InfoWindow",
    props: [
        "title",
        "location",
        "address",
        "added",
        "restId"
    ],
    data: function() {
      return {
        isNew: !this.added,
        id: this.restId
      }
    },
    methods: {
      addRestaurant: function() {
        const newRestaurant = {
          name: this.title,
          location: this.location,
          userId: auth.currentUser.uid,
          address: this.address
        }
        // console.log(newRestaurant)
        this.isNew = false
        db.collection("restaurants").add(newRestaurant)
        .then((docRef) => {
            this.id = docRef.id;
        })
        .catch((error) => {
            console.error("Error adding document: ", error);
        });
      },

      goToRestaurant() {
        router.push({ name: 'Restaurant', params: { id: this.id } })
      }
    }
}
</script>